import './css/Footer.css'
import { Link } from 'react-router-dom';


function Footer() {
    return (
        <div className="footer">
            <div className='div1'>
                <Link to="/seo">Pre Firmy</Link>
                <Link to="/">Domov</Link>
                <Link to="/toc">Obchodné podmienky</Link>
                <Link to="/catalog">Katalóg</Link>
            </div>

            <div className='div2'>
{/* 
                <p>📞 <a href="tel:0908 482 517">0908 482 517</a></p>
                <p>✉️ <a href="mailto:info@sluzbomat.sk">info@sluzbomat.sk</a></p> */}
            </div>
        </div>
    );
}

export default Footer;